import React from "react";
import { createRoot } from "react-dom/client";
import { AppThemeProvider } from "./ThemeContext";
import Routes from "./Routes";
import "./styles.css";

const root = createRoot(document.getElementById("root"));
root.render(
  <AppThemeProvider>
    <Routes />
  </AppThemeProvider>
);
